import { Action } from 'redux';

import { UpdateAssetListItems } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { AssetListItem } from '../models/AssetListItem';

export interface UpdateAssetListItemsAction extends Action {
  items: AssetListItem[];
}

export function updateAssetListItems(items: AssetListItem[]) {
  return {
    type: UpdateAssetListItems,
    items,
  };
}

export const isUpdateAssetListItemsAction = isActionFactory<UpdateAssetListItemsAction>(UpdateAssetListItems);
